import {
  CREATE_PROJECTS_REQUEST,
  CREATE_PROJECTS_ERROR,
  CREATE_PROJECTS_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => async (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITIES_REQUEST = CREATE_PROJECTS_REQUEST;
  context.CREATE_ENTITIES_ERROR = CREATE_PROJECTS_ERROR;
  context.CREATE_ENTITIES_SUCCESS = CREATE_PROJECTS_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projects";
  context.entityLocation = RESOURCES.Projects;
  context.hasOrganisation = true;

  return context.execute(context)(entity)(state, action);
};